import axios from 'axios';
import { from } from 'rxjs';

export const markAsShipped = (orderData) =>
  from(axios.post('/fulfillmentPlan/markascomplete', orderData).then((response) => response.data));

export const undoMarkAsShipped = (fulfillmentPlanIds) =>
  from(axios.post('/fulfillmentPlan/undoMarkAsComplete', { fulfillmentPlanIds }).then((response) => response.data));

export const undoMarkAsShippedFromOrderDetails = (fulfillmentId) => axios.put('/fulfillment/undoMarkAsShipped', { fulfillmentId });

export const validateBulkMarkAsShipped = (text, storeGuid, shouldExcludeOrdersWithErrors) =>
  axios
    .post('/fulfillmentPlan/markascomplete/bulk', {
      text,
      storeGuid,
      shouldExcludeOrdersWithErrors,
    })
    .then((res) => res.data);
